/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lightbulb': {
    width: 15,
    height: 20,
    viewBox: '0 0 15 20',
    data: '<path d="M4.55469 16.1H10.5469" stroke="#768692" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M5.26562 19H9.73438" stroke="#768692" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M13.3906 10.2C13.7969 9.4 14 8.4 14 7.4C14 3.9 11.1562 1 7.5 1C3.84375 1 1 3.9 1 7.4C1 8.4 1.20313 9.3 1.60938 10.2C3.03125 10.7 4.04688 11.7 4.55469 13.1C4.65625 13.1 4.65625 13.2 4.75781 13.2H10.3437C10.4453 13.2 10.4453 13.1 10.5469 13.1C10.9531 11.7 12.0703 10.7 13.3906 10.2Z" stroke="#768692" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})